var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedeemAKey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 229,
    height: 60,
    viewBox: "0 0 229 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M228.422 30L197.434 59.3769L196.957 58.9248V59.6022H189.681L188.476 58.528L188.33 58.3977L188.137 58.4342L181.977 59.6022H76.3657L74.375 57.3139L73.6862 57.6595L74.1087 59.6022H32.1484V58.8249L31.5661 59.3769L0.578132 30L31.5661 0.623073L32.1484 1.17513V0.397749H32.4636L35.6886 1.69405L35.9331 1.79231L36.1189 1.60556L37.3208 0.397749H112.313H114.159H196.957V1.07524L197.434 0.623095L228.422 30Z",
    fill: "url(#paint0_linear_2151_74)",
    stroke: "url(#paint1_linear_2151_74)",
    strokeWidth: 0.795498
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2151_74",
    x1: 113.949,
    y1: 0.263833,
    x2: 114.505,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2151_74",
    x1: 129.172,
    y1: -185.667,
    x2: 109.695,
    y2: 105.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDDBAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477083,
    stopColor: "#FFEA9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#693E18"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedeemAKey);
export default __webpack_public_path__ + "static/media/redeem-a-key.4e3031eaf8b184aa6bf7a12ce6558d97.svg";
export { ForwardRef as ReactComponent };